import type { Runtime } from './runtime';
import type { LoadingScreen } from '../ui/types';

/** Keep the opaque gateway over the canvas while the GPU presents the first city frame. */
export function revealCity(runtime: Runtime, screen: LoadingScreen, win: Window): void {
  runtime.input?.setEnabled(false);
  const reveal = (): void => {
    screen.hide();
    runtime.menuOpen = false;
    runtime.input?.setEnabled(!runtime.ui.helpOpen);
  };
  if (win.document.hidden) reveal();
  else win.requestAnimationFrame(reveal);
}
